import { computed, ref } from 'vue';

interface CursorPosition {
	x: number;
	y: number;
}

/**
 * Anchors a floating menu to a cursor position. Tracks the last pointer coordinates and exposes a
 * zero-size virtual element whose bounding rect sits at that point, for `DDropdownMenu`'s
 * `:content="{ reference }"`. Used for cursor-anchored context menus that have no real trigger element.
 */
export function useCursorAnchor() {
	const position = ref<CursorPosition>({ x: 0, y: 0 });

	const reference = computed(() => {
		const { x, y } = position.value;

		return {
			getBoundingClientRect: () => ({
				x,
				y,
				width: 0,
				height: 0,
				top: y,
				right: x,
				bottom: y,
				left: x,
			}),
		};
	});

	function anchorTo(event: MouseEvent) {
		position.value = { x: event.clientX, y: event.clientY };
	}

	return { reference, anchorTo };
}
